<template>
  <div class="locale-switcher d-flex align-items-center w-100">
    <FormSelect
      :items="languageOptions"
      :value="languageOptions.find((op) => op.value === $i18n.locale)"
      class="w-100 px-3"
      item-text="text"
      item-value="value"
      @change="$i18n.locale = $event.value"
    />
    <!--    <b-form-select v-model="$i18n.locale" class="">-->
    <!--      <b-form-select-option value="cz">-->
    <!--        Čeština-->
    <!--      </b-form-select-option>-->
    <!--      <b-form-select-option value="en">-->
    <!--        English-->
    <!--      </b-form-select-option>-->
    <!--    </b-form-select>-->
  </div>
</template>

<script>
import FormSelect from "@/components/forms/FormSelect.vue"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: { FormSelect },
  setup() {
    const configStore = useConfigStore()

    return { configStore }
  },
  data() {
    return {
      languageOptions: [
        { value: "cz", text: "Čeština" },
        { value: "en", text: "English" }
      ]
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale() {
      this.configStore.setLang()
    }
  }
}
</script>

<style lang="scss" scoped></style>
